import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthStore } from "@/stores/authStore";
import { Loader2 } from "lucide-react";

export function SplashScreen() {
  const { isAuthenticated, isLoading, status, checkAuth } = useAuthStore();
  const navigate = useNavigate();

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  useEffect(() => {
    if (!isLoading) {
      if (!isAuthenticated) {
        navigate("/login", { replace: true });
      } else if (status === "needsEmailVerification") {
        navigate("/verify-email", { replace: true });
      } else if (status === "needsSubscription") {
        navigate("/subscription", { replace: true });
      } else if (status === "complete") {
        navigate("/dash", { replace: true });
      }
    }
  }, [isAuthenticated, isLoading, status, navigate]);

  return (
    <div className="flex h-screen flex-col items-center justify-center bg-background">
      <h1 className="mb-8 text-3xl font-bold text-primary">Swift Menu</h1>
      <Loader2 className="h-8 w-8 animate-spin text-primary" />
    </div>
  );
}
